<template>
  <success-page-layout
    :cta-copy="$t('ctaCopy')"
    store-badges-button-code="body-20210304-success-page-churn-prevention"
    :promote-app-download="false"
  >
    <template v-slot:content>
      <b-headline type="h1" typography="h2" class="mb-4 m:mb-6" v-html="$t('headline')" />
      <p v-html="copy" />
    </template>

    <template v-slot:image>
      <churn-prevention-image />
    </template>
  </success-page-layout>
</template>

<script>
import { getSearchParam } from "@/utils/location"
import formatDate from "@/utils/date-formatter"
import BHeadline from "@/component-library/b-headline"
import SuccessPageLayout from "@/pages/success-page/components/success-page-layout"
import ChurnPreventionImage from "@/pages/success-page/components/churn-prevention/image"

export default {
  name: "JoinOrganisationSuccess",
  components: {
    ChurnPreventionImage,
    BHeadline,
    SuccessPageLayout
  },
  computed: {
    sku() {
      return getSearchParam("sku")
    },
    renewalDate() {
      const dateParam = getSearchParam("date")
      return formatDate(new Date(dateParam), this.$i18n.locale)
    },
    copy() {
      return this.$te(`copy.${this.sku}`)
        ? this.$t(`copy.${this.sku}`, { renewalDate: this.renewalDate })
        : this.renewalDate
    }
  },
  i18n: {
    messages: {
      en: {
        ctaCopy: "Continue exploring",
        headline: "Great!<br>Let’s keep the powerful ideas coming.",
        copy: {
          yearly: "You’ll get 50% off on your next yearly renewal.<br />Your renewal will be on {renewalDate}.",
          monthly: "You’ll get 50% off on your next monthly renewal.<br />Your renewal will be on {renewalDate}.",
          trial: "You will get 50% off on your next yearly renewal.<br />Your renewal will be on {renewalDate}."
        }
      },
      de: {
        ctaCopy: "Weiter entdecken",
        headline: "Super! Entdecke weiterhin große Ideen mit Blinkist.",
        copy: {
          yearly: "Auf das nächste Jahr Premium ab dem {renewalDate} erhältst du automatisch 50% Rabatt.",
          monthly: "Auf den nächsten Monat ab dem {renewalDate} Premium erhältst du automatisch 50% Rabatt.",
          trial: "Auf dein erstes Jahr Premium ab dem {renewalDate} erhältst du automatisch 50% Rabatt."
        }
      },
      es: {
        ctaCopy: "Seguir explorando",
        headline: "¡Genial!<br>Sigue descubriendo grandes ideas.",
        copy: {
          yearly: "Obtendrás un 50 % de descuento en tu próxima renovación anual.<br />Tu renovación será el {renewalDate}.",
          monthly: "Obtendrás un 50 % de descuento en tu próxima renovación mensual.<br />Tu renovación será el {renewalDate}.",
          trial: "Obtendrás un 50 % de descuento en tu próxima renovación anual.<br />Tu renovación será el {renewalDate}."
        }
      },
      pt: {
        ctaCopy: "Continuar explorando",
        headline: "Ótimo!<br>Continue descobrindo grandes ideias.",
        copy: {
          yearly: "Você receberá 50% de desconto na sua próxima renovação anual.<br />Sua renovação será em {renewalDate}.",
          monthly: "Você receberá 50% de desconto na sua próxima renovação mensal.<br />Sua renovação será em {renewalDate}.",
          trial: "Você receberá 50% de desconto na sua próxima renovação anual.<br />Sua renovação será em {renewalDate}."
        }
      }
    }
  }
}
</script>
